
import { Vue, Component } from 'vue-property-decorator';
import { getRule } from '../api';
@Component
export default class Rule extends Vue {
  data: string = '';
  async mounted() {
    const res: any = await getRule();
    this.data = res.data;
  }
}
